export const getYLocationForDepthInM = (pxPerM: number, depthInM: number, visibleRangeFrom: number): number => {
	return pxPerM * (depthInM - visibleRangeFrom);
};
